<template>
  <v-dialog
    :value="flagAlert"
    persistent
    width="520"
    content-class="app-alert-dialog"
  >
    <v-card class="app-alert" flat>
      <v-card-text class="app-alert__content">
        <v-icon class="app-alert__icon" size="82" aria-hidden="true">
          {{ alertIcon }}
        </v-icon>
        <h2 class="app-alert__message">{{ mesAlert }}</h2>
        <v-btn class="app-alert__button" depressed @click="CloseAlert()">
          {{ typeAlert === "success" ? "Completed" : "Close" }}
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    flagAlert: {
      type: Boolean,
      default: false,
    },
    typeAlert: {
      type: String,
      default: null,
    },
    mesAlert: {
      type: String,
      default: null,
    },
  },
  computed: {
    alertIcon() {
      const icons = {
        success: "mdi-check-circle-outline",
        warning: "mdi-alert-circle-outline",
        error: "mdi-close-circle-outline",
        info: "mdi-information-outline",
      };
      return icons[this.typeAlert] || icons.info;
    },
  },
  methods: {
    CloseAlert() {
      this.$emit("flagClose");
    },
  },
};
</script>

<style>
.app-alert-dialog {
  overflow: hidden;
  border: 1px solid #777273;
  border-radius: 12px;
  box-shadow: 0 12px 24px rgba(38, 34, 35, 0.22);
}

.app-alert {
  background: #ffffff !important;
  color: #262223;
}

.app-alert__content {
  min-height: 390px;
  padding: 54px 48px 42px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.app-alert__icon {
  margin-bottom: 42px;
  color: #342e30 !important;
}

.app-alert__message {
  margin: 0;
  color: #262223;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 34px;
  font-weight: 400;
  line-height: 1.18;
  letter-spacing: 0.01em;
  text-wrap: balance;
}

.app-alert__button {
  min-width: 230px !important;
  min-height: 52px !important;
  margin-top: 72px;
  padding: 10px 28px !important;
  border-radius: 999px !important;
  background: #262223 !important;
  box-shadow: 0 8px 8px rgba(38, 34, 35, 0.28) !important;
  color: #ffffff !important;
  font-family: "Mrs Eaves Lining OT", "Times New Roman", serif !important;
  font-size: 21px !important;
  font-weight: 400 !important;
  letter-spacing: 0.01em !important;
  text-transform: none !important;
}

.app-alert__button:hover,
.app-alert__button:focus-visible {
  background: #403a3c !important;
}

@media (max-width: 600px) {
  .app-alert-dialog {
    width: calc(100vw - 32px) !important;
    margin: 16px;
  }

  .app-alert__content {
    min-height: 360px;
    padding: 42px 24px 32px !important;
  }

  .app-alert__icon {
    margin-bottom: 34px;
    font-size: 68px !important;
  }

  .app-alert__message {
    font-size: 29px;
  }

  .app-alert__button {
    min-width: min(100%, 210px) !important;
    min-height: 50px !important;
    margin-top: 52px;
    font-size: 19px !important;
  }
}
</style>
